import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';
import { AccountType, PayedBy } from '../../../shared/Constants';

const AccountManagementSideMenuBuilder = (accountId, accountType, payedBy, isHeadOfFamily) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildManageOwnSubscriptionTab = () => {
    return {
      label: formatMessage(i18nMessages.manage),
      icon: 'pi pi-briefcase',
      command: () => {
        const url = `/accounts/${accountId}/manage-own-subscription`;
        history.push(url);
      },
    };
  };

  const buildBuyOrReactivateOwnSubscription = () => {
    const buyOrReactivate = {
      label: formatMessage(i18nMessages.buyOrReactivate),
      icon: 'pi pi-check',
      command: () => {
        const url = `/accounts/${accountId}/buy-or-reactivate-own-subscription`;
        history.push(url);
      },
    };

    return buyOrReactivate;
  };

  const buildInvoices = () => {
    return {
      label: formatMessage(i18nMessages.invoices),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/invoices`;
        history.push(url);
      },
    };
  };

  const buildUserTabs = () => {
    const userTabs = {
      label: formatMessage(i18nMessages.users),
      icon: 'pi pi-user',
      items: [
        {
          label: formatMessage(i18nMessages.listUsers),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/users`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addUser),
          icon: 'pi pi-user-plus',
          command: () => {
            const url = `/accounts/${accountId}/users/invite`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.listUserInvitations),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/users/invitations`;
            history.push(url);
          },
        },
      ],
    };

    return userTabs;
  };

  const buildAccountTabs = () => {
    const accountTabs = {
      label: formatMessage(i18nMessages.accounts),
      icon: 'pi pi-th-large',
      items: [
        {
          label: formatMessage(i18nMessages.settings),
          icon: 'pi pi-cog',
          command: () => {
            const url = `/accounts/${accountId}/settings`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.listFamilyAccounts),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/accounts/family-accounts`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addFamilyAccount),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/accounts/add-sub-account`;
            history.push(url);
          },
        },
      ],
    };

    return accountTabs;
  };

  const buildCreditTabs = () => {
    const newTransferTab = {
      label: formatMessage(i18nMessages.transferCredits),
      icon: 'pi pi-refresh',
      command: () => {
        const url = `/accounts/${accountId}/family-transfers/new`;
        history.push(url);
      },
    };

    const transferLogTab = {
      label: formatMessage(i18nMessages.transferLog),
      icon: 'pi pi-align-left',
      command: () => {
        const url = `/accounts/${accountId}/family-transfers`;
        history.push(url);
      },
    };

    const consumptionLogTab = {
      label: formatMessage(i18nMessages.consumptionLog),
      icon: 'pi pi-chart-bar',
      command: () => {
        const url = `/accounts/${accountId}/consumption`;
        history.push(url);
      },
    };

    const buyCreditsTab = {
      label: formatMessage(i18nMessages.buyCredits),
      icon: 'pi pi-dollar',
      command: () => {
        const url = `/accounts/${accountId}/buy-credits`;
        history.push(url);
      },
    };

    let creditTabItems = [];

    // const accountCanBuyCredits =
    //   accountType === AccountType.MCP || accountType === AccountType.GSC || accountType === AccountType.ESSENTIAL;
    const accountCanBuyCredits = accountType === AccountType.MCP;

    if (accountCanBuyCredits) {
      creditTabItems = [newTransferTab, transferLogTab, consumptionLogTab, buyCreditsTab];
    } else {
      creditTabItems = [newTransferTab, transferLogTab, consumptionLogTab];
    }

    const creditTabs = {
      label: formatMessage(i18nMessages.creditsManagement),
      icon: 'pi pi-briefcase',
      items: creditTabItems,
    };

    return creditTabs;
  };

  const buildNoLimitTabs = () => {
    const manageOwnSubscriptionTab = buildManageOwnSubscriptionTab();
    const buyOrReactivateOwnSubscription = buildBuyOrReactivateOwnSubscription();
    const invoices = buildInvoices();

    const items = [manageOwnSubscriptionTab, buyOrReactivateOwnSubscription, invoices];

    return {
      label: formatMessage(i18nMessages.noLimit),
      icon: 'pi pi-dollar',
      items,
    };
  };

  const buildAccountManagementMenu = () => {
    const userTabs = buildUserTabs();
    const accountTabs = buildAccountTabs();
    const creditTabs = buildCreditTabs();
    const noLimitTabs = buildNoLimitTabs();

    const items = [userTabs, accountTabs];

    // const accountCanHaveCredits =
    //   accountType === AccountType.GPI ||
    //   accountType === AccountType.GSC ||
    //   accountType === AccountType.CLIENT ||
    //   accountType === AccountType.CP ||
    //   accountType === AccountType.MCP ||
    //   accountType === AccountType.ESSENTIAL;
    const accountCanHaveCredits =
    accountType === AccountType.GPI ||
    accountType === AccountType.CLIENT ||
    accountType === AccountType.CP ||
    accountType === AccountType.MCP;

    const accountCanManageOwnSubscription =
      isHeadOfFamily &&
      (accountType === AccountType.GSC ||
        accountType === AccountType.GP ||
        (accountType === AccountType.NBM_CLIENT && payedBy === PayedBy.PAYED_BY_SELF));

    if (accountCanHaveCredits) {
      items.push(creditTabs);
    }

    if (accountCanManageOwnSubscription) {
      items.push(noLimitTabs);
    }

    const accountManagement = {
      label: formatMessage(i18nMessages.accountManagement),
      icon: 'pi pi-sitemap',
      items,
    };

    return accountManagement;
  };

  return {
    buildAccountManagementMenu,
  };
};

export default AccountManagementSideMenuBuilder;
